import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { getSISContract } from '~/contracts/getSISContract'
import { sisTokenKeys } from '~/lib/queryKeys'
import { useWallet } from '~/lib/useWallet'
import { CONFIG } from '~/lib/config'
import { symbiosis } from '~/lib/symbiosis'

const VESIS_CONIFG = CONFIG.vesis[0]
const provider = symbiosis.getProvider(VESIS_CONIFG.chain.id)

export function useGetTestSIS() {
	const { signer, account } = useWallet()

	const queryClient = useQueryClient()

	const { data, isLoading } = useQuery({
		queryKey: sisTokenKeys.availableToClaim(VESIS_CONIFG.chain.id, account),
		queryFn: () => {
			const contract = getSISContract(VESIS_CONIFG, provider)

			return contract.availableToClaim(account)
		},
		enabled: !!account,
	})

	const { isPending: isReceiving, mutate } = useMutation({
		mutationFn: async () => {
			const contract = getSISContract(VESIS_CONIFG, provider).connect(
				signer
			)

			const tx = await contract.claim(account)

			await tx.wait()
		},
		onSuccess() {
			queryClient.resetQueries({
				queryKey: sisTokenKeys.balance(VESIS_CONIFG.chain.id, account),
			})
			queryClient.resetQueries({
				queryKey: sisTokenKeys.availableToClaim(
					VESIS_CONIFG.chain.id,
					account
				),
			})
		},
		onError(error) {
			console.error('Error claiming test SIS:', error)
		},
	})

	const isAvailable = !isLoading && data

	return {
		getTestSIS: mutate,
		isReceiving,
		isAvailable,
	}
}
